import React, { useState } from "react";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";

const testimonials = [
  {
    name: "Ing. Gustavo R.",
    role: "Supervisor de Redes",
    text: "La instalación y puesta en marcha de nuestros transformadores nunca había sido tan eficiente. El equipo trabajó con precisión, respetó los protocolos de seguridad y entregó todo antes del plazo acordado. Nuestras interrupciones bajaron significativamente.",
  },
  {
    name: "María Fernanda L.",
    role: "Administradora del Parque Industrial",
    text: "Contratamos mantenimiento preventivo y correctivo para nuestros transformadores de 75 y 112.5 kVA. El diagnóstico fue muy completo, el trabajo limpio y el reporte técnico nos ayudó a planear acciones futuras. Aliado confiable.",
  },
  {
    name: "Carlos M.",
    role: "Director de Obras",
    text: "Durante un proyecto complejo en zona rural, Transformadores Bucaramanga se encargó del suministro, izaje e instalación de un transformador en condiciones difíciles. Su experiencia en campo marcó la diferencia y garantizó la continuidad de la obra.",
  },
];

export default function Testimonials() {
  const [i, setI] = useState(0);
  const t = testimonials[i];
  const prev = () => setI((i - 1 + testimonials.length) % testimonials.length);
  const next = () => setI((i + 1) % testimonials.length);

  return (
    <section
      id="testimonios"
      data-testid="testimonials-section"
      className="relative py-24 lg:py-32 bg-[#0a0a0a]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#ff6b00] mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-[#ff6b00]" />
              <span>Testimonios</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tighter mb-8">
              Lo que dicen
              <br />
              quienes confían
              <br />
              en nosotros.
            </h2>
            <div className="flex items-center gap-1 mb-6">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-4 h-4 fill-[#ff6b00] text-[#ff6b00]"
                />
              ))}
              <span className="text-xs text-[#a0aabf] ml-3 font-mono">
                4.9/5 · 120+ reseñas
              </span>
            </div>
            <div className="flex items-center gap-3">
              <button
                data-testid="testimonial-prev"
                onClick={prev}
                className="w-12 h-12 border border-white/10 hover:border-[#ff6b00] hover:bg-[#ff6b00]/10 transition-colors grid place-items-center"
                aria-label="Anterior"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button
                data-testid="testimonial-next"
                onClick={next}
                className="w-12 h-12 border border-white/10 hover:border-[#ff6b00] hover:bg-[#ff6b00]/10 transition-colors grid place-items-center"
                aria-label="Siguiente"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
              <span className="font-mono text-xs text-[#a0aabf] ml-3">
                {String(i + 1).padStart(2, "0")} / {String(testimonials.length).padStart(2, "0")}
              </span>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div
              key={i}
              data-testid="testimonial-card"
              className="relative bg-[#12141a] border border-white/5 p-8 lg:p-12 min-h-[340px]"
            >
              <Quote
                className="absolute top-8 right-8 w-16 h-16 text-[#ff6b00]/10"
                strokeWidth={1}
              />
              <p className="text-xl lg:text-2xl text-white leading-relaxed font-light mb-10">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="pt-6 border-t border-white/5">
                <div className="font-display text-lg font-semibold">{t.name}</div>
                <div className="text-sm text-[#a0aabf] mt-1">{t.role}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
